import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import empValidationSchema from '../../validations/Bid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";


function EmpUpdateProfileForm({}) {

  React.useEffect(() => {
    // AuthHelper.checkAuth()
    fetchMetadataOfBidByEmp({form_action: form_action })
    if (form_action == 'update') {
      fetchBidDetailsBidBySeller({})
    }
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  let form_action = searchParams.get('form_action');
  // console.log('---form_action:', form_action);

  const navigate = useNavigate();
  const { auth_user } = useSelector((state) => state.authUser)
  // console.log('---EmpUpdateProfileForm--auth_user:', auth_user);

  const [initialValues, setInitialValues] = React.useState({
    'first_name': '',
    'last_name': '',
    'email': '',
    'mob_number': '',
  });
  // console.log('---initialValues---111:', initialValues);
  const [bidMetaDetails, setBidMetaDetails] = React.useState({});
  // console.log('----bidMetaDetails:', bidMetaDetails)
  const dispatch = useDispatch();


  const handleBidResponse = values => {
    console.log('---handleBidResponse--values:', values);
    sendBidResponse(values);
  }

  const formik = useFormik({
    initialValues,
    // onSubmit: (values, action) => console.log('okodkodw'),
    onSubmit: handleBidResponse,
    // validate,
    validationSchema: empValidationSchema.empUpdateProfileSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
  }

  const errorResponse = (error) => {
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---221:', formik.errors);
  }

  const sendBidResponse = async (data = {}) => {
    try {
      const response = await callApi.requestPUT(`/sellers-bids/emp/update-profile`, data, true)
      console.log('---sendBidResponse---response:', response);
      successResponse(response)
    }
    catch (error) {
      // console.log('---sendBidResponse---error:', error);
      errorResponse(error)
    }
  }

  const fetchBidDetailsBidBySeller = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/emp/bids-listing`, data, true)
      // console.log('---fetchBidDetailsBidBySeller---response:', response);
      // setInitialValues(() => response.data.data.dataset[0])
      formik.setValues(response.data.data.dataset[0])
    }
    catch (error) {
      // console.log('---fetchBidDetailsBidBySeller---error:', error);
      errorResponse(error)
    }
  }

  const fetchMetadataOfBidByEmp = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/emp/profile-details`, data, true)
      // console.log('---fetchMetadataOfBidByEmp---response:', response);
      // console.log('---fetchMetadataOfBidByEmp---setBidMetaDetails---response:', response.data.data.dataset[0]);
      // setBidMetaDetails(() => response.data.data.dataset[0])
      // setBidMetaDetails(response.data.data.dataset[0])
      formik.setValues(response.data.data.dataset[0])
    }
    catch (error) {
      // console.log('---fetchMetadataOfBidByEmp---error:', error);
      errorResponse(error)
    }
  }


  return (
    <div>
      <div>

        <Box component="form" className="" onSubmit={formik.handleSubmit}>
          <div className='tw-grid mob:tw-grid-cols-2 desktop:tw-grid-cols-2 tw-gap-5'>

            <div className='tw-col-span-1'>
              <TextField id="firstNameId" label="First Name" type="text" name="first_name" variant="outlined" onChange={formik.handleChange} value={formik.values.first_name} error={formik.errors.first_name ? true : false} helperText={formik.errors.first_name} required />
            </div>

            <div className='tw-col-span-1'>
              <TextField id="lastNameId" label="Last Name" type="text" name="last_name" variant="outlined" onChange={formik.handleChange} value={formik.values.last_name} error={formik.errors.last_name ? true : false} helperText={formik.errors.last_name} required />
            </div>

            <div className='tw-col-span-2'>
              <TextField disabled id="emailId" label="Email" type="email" name="email" variant="outlined" fullWidth onChange={formik.handleChange} value={formik.values.email} error={formik.errors.email ? true : false} helperText={formik.errors.email} />
            </div>

            <div className='tw-col-span-2'>
              <TextField disabled id="mobNumberId" label="Mobile Number" type="text" name="mob_number" fullWidth variant="outlined" onChange={formik.handleChange} value={formik.values.mob_number} error={formik.errors.mob_number ? true : false} helperText={formik.errors.mob_number} />
            </div>

            <div className='tw-col-span-1 mob:tw-col-start-1 desktop:tw-col-start-1'>
              <Button type="submit" variant="contained">Submit</Button>
            </div>

          </div>
        </Box>

      </div>

      <Snackbar />
    </div>
  );

}


export { EmpUpdateProfileForm };
